module.exports = __webpack_public_path__ + "img/kadin.69dc6082.png";